import { render } from "./ClassPicker.vue?vue&type=template&id=1f3e6b16&ts=true"
import script from "./ClassPicker.vue?vue&type=script&lang=ts"
export * from "./ClassPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__